<h2>LAVORI IN AZIENDA?</h2>
<p> L'associazione De Cifris collabora con diverse aziende che si occupano di crittografia,
	coinvolgendo circa 250 professionisti del mondo aziendale. </p>
<p> Uno dei suoi obiettivi è infatti quello di creare un ponte tra il mondo accademico e quello
	aziendale attraverso, ad esempio, l'<a routerLink="/associazione/advisory-board">Advisory Board "De Cifris"</a> che offre
	possibilità di
	tirocinio/stage in azienda a laureandi e laureati, creando una comunicazione diretta tra i corsi di
	laurea con curricula volti allo studio della crittografia e le esigenze aziendali. </p>
<p>
	La De Cifris si propone anche di aiutare le aziende coinvolte nella stesura di progetti e proposte
	crittografiche e di suggerire collaborazioni con i propri membri in relazione alle loro competenze.</p>